<template>
  <Head title="Manage Clients" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <manage-clients :client="client" :agencies="agencies" :user="auth.user"></manage-clients>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';
import ManageClients from '../../components/admin/ManageClients.vue';

defineProps({
  auth: {
    type: Object,
    required: true
  },
  client: {
    type: Object,
    default: null
  },
  agencies: {
    type: Array,
    required: true
  }
});
</script>

